export default "__VITE_ASSET__ac23c3b3__"